export default __webpack_public_path__ + "static/media/bubble-board.54d7c4e6.png";